module.exports = __webpack_public_path__ + "img/submitted.c39bca64.png";